@if (canSubmit(item()) && !hasAnswer() && isStudentOrResponsible()) {
  @let action = actionFn();
  <button
    app-button
    (click)="action()"
    class="flex-row items-center gap-2 rounded-lg border-black/10 bg-white px-4 text-black border border-solid"
  >
    <svg-icon class="w-5 h-5 flex items-center justify-center" [src]="'icon-upload-fine' | icon"></svg-icon>
    <span class="text-base" translate>gestor-avaliacoes.iniciar</span>
  </button>
}
